import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveLine } from '@nivo/line';
import styles from './LineGraph.module.scss';

const LINE_GRAPH_REGULAR_FORMAT = ' >-,.0f';
const LINE_GRAPH_CURRENCY_FORMAT = ' >-$0,.2f';

function currencyFormatter(value) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(value);
}

function LineGraph(props) {
  const { isCurrency } = props;
  const cymbioColors = ['#5c03ec'];

  const tickValuesCount = new Set();
  let maxValue = 0,
    minValue = Number.MAX_VALUE;

  props.data[0].data.forEach((item) => {
    tickValuesCount.add(item.y);
    maxValue = Math.max(maxValue, item.y);
    minValue = Math.min(minValue, item.y);
  });

  const tooltip = (tooltipData) => {
    const { data } = tooltipData.point;
    return (
      <div className={styles.tooltip}>
        <div>
          <label>Date:</label>
          <span>{data.xFormatted}</span>
        </div>
        <div>
          <label>{props.graphTitle}:</label>
          <span>{data.yFormatted}</span>
        </div>
      </div>
    );
  };

  return (
    <div style={{ height: props.height }} data-testid="line-graph-wrapper">
      <ResponsiveLine
        margin={{
          top: 20,
          right: 20,
          bottom: 120,
          left: 90,
        }}
        animate={true}
        useMesh={true}
        curve="monotoneX"
        data={props.data}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', stacked: false, min: Math.max(minValue - 1, 0), max: maxValue + 1 }}
        yFormat={isCurrency ? LINE_GRAPH_CURRENCY_FORMAT : LINE_GRAPH_REGULAR_FORMAT}
        pointLabelYOffset={0}
        axisBottom={{ orient: 'bottom', tickRotation: -45 }}
        axisLeft={{
          tickValues: tickValuesCount.size + 2,
          format: (value) => (isCurrency ? currencyFormatter(value) : value),
        }}
        enableDotLabel={false}
        colors={cymbioColors}
        tooltip={tooltip}
      />
    </div>
  );
}

LineGraph.defaultProps = {
  height: 600,
  isCurrency: false,
};

LineGraph.propTypes = {
  height: PropTypes.number.isRequired,
  isCurrency: PropTypes.bool.isRequired,
  graphTitle: PropTypes.string.isRequired,
};

export default LineGraph;
